/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_ActionsInputs */

const id_tld_pricing_column_actions = /** @type {(inputs: Tld_Pricing_Column_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan`)
};

const en_tld_pricing_column_actions = /** @type {(inputs: Tld_Pricing_Column_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Tld_Pricing_Column_ActionsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_actions = /** @type {((inputs?: Tld_Pricing_Column_ActionsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_ActionsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_actions(inputs)
	return id_tld_pricing_column_actions(inputs)
});